export default __webpack_public_path__ + "static/media/noChat.816ab19f.svg";